import React from 'react';

import { OptionProps, components } from 'react-select';

import { AssigneeAvatar } from 'components/common/AssigneeAvatar/AssigneeAvatar';

import { IAssignee } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';
import classes from 'components/DesignSystem/Select/components/OptionsWithAssignee/OptionsWithAssignee.module.scss';

export const OptionsWithAssignee = <T,>(props: OptionProps<T> & { data: { label: string; assignee: IAssignee } }) => {
    const { assignee, label } = props.data;

    return (
        <components.Option {...props}>
            <div className={classes.labelWithAssigneeWrapper}>
                <AssigneeAvatar assignee={assignee} />
                {label}
            </div>
        </components.Option>
    );
};
